import { useQuery } from '@tanstack/react-query';

import { authFetch } from '@verantos-dev/core-utils';
import type { ObjectResponse } from '@verantos-dev/types-common';

import { analysisKeys } from './queryKeys';
import type { AnalysisResults } from './types';

interface UseAnalysisResultsQueryArgs {
  projectId: string;
  analysisProfileId: string;
}

// The latest version's table shells populated with the latest run's cells.
export const useAnalysisResultsQuery = ({
  projectId,
  analysisProfileId,
}: UseAnalysisResultsQueryArgs) => {
  return useQuery({
    queryKey: analysisKeys.results(analysisProfileId),
    queryFn: () =>
      authFetch<ObjectResponse<AnalysisResults>>(
        `/analyses/${encodeURIComponent(projectId)}` +
          `/analysis-profile/${encodeURIComponent(analysisProfileId)}/results`
      ),
    enabled: projectId.length > 0 && analysisProfileId.length > 0,
    retry: false,
  });
};
